import * as ErrorConstants from '../../../constants/ErrorConstants';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';

const bureauValidateNipView = (state = defaultState.creditoReal.ui.bureauValidateNipView, action) => {
    switch (action.type) {
        case WizardMXActions.GOT_API_ERROR_ACTION.name:
            return {
                ...state,
                hasNipValidationError: action.error === ErrorConstants.INVALID_NIP_CODE_ERROR
            };
        case WizardMXActions.CLEAN_NIP_MX_ACTION.name:
        case WizardMXActions.CHANGE_BUREAU_NIP_ACTION.name:
            return {
                ...state,
                hasNipValidationError: false
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return defaultState.creditoReal.ui.bureauValidateNipView;
        default:
            return state;
    }
};

export default bureauValidateNipView;